import type { Tournament } from '@/types/tournament.model';
import { TournamentStatus } from '@/types/tournament.model';

export { TournamentStatus };

export const isTournamentCancelled = (tournament: Tournament): boolean =>
  tournament.status === TournamentStatus.CANCELLED;

export const isTournamentFinished = (tournament: Tournament): boolean =>
  tournament.status === TournamentStatus.FINISHED;

export const isTournamentInProgress = (tournament: Tournament): boolean =>
  tournament.status === TournamentStatus.IN_PROGRESS;

// Statuses a manager still acts on, ordered by urgency: in progress first,
// upcoming after. Drives both the membership test and the display order.
export const ACTIVE_TOURNAMENT_STATUSES: readonly TournamentStatus[] = [
  TournamentStatus.IN_PROGRESS,
  TournamentStatus.OPEN,
];

export const isTournamentActive = (tournament: Tournament): boolean =>
  ACTIVE_TOURNAMENT_STATUSES.includes(tournament.status);

export const getTournamentStatus = (tournament: Tournament): TournamentStatus =>
  tournament.status;

export const getStatusLabel = (status: TournamentStatus): string => {
  switch (status) {
    case TournamentStatus.OPEN:
      return 'Próximo';
    case TournamentStatus.IN_PROGRESS:
      return 'En Juego';
    case TournamentStatus.FINISHED:
      return 'Finalizado';
    case TournamentStatus.CANCELLED:
      return 'Cancelado';
    default:
      return '';
  }
};

export const getStatusColor = (status: TournamentStatus): string => {
  switch (status) {
    case TournamentStatus.OPEN:
      return 'bg-emerald-100 text-emerald-700 border-emerald-200';
    case TournamentStatus.IN_PROGRESS:
      return 'bg-blue-100 text-blue-700 border-blue-200';
    case TournamentStatus.FINISHED:
      return 'bg-gray-200 text-gray-800 border-gray-300';
    case TournamentStatus.CANCELLED:
      return 'bg-red-100 text-red-700 border-red-200';
    default:
      return 'bg-gray-100 text-gray-700 border-gray-200';
  }
};
